import { ClientConfigurationModel } from "@common/models";
import { UserStoreContextWrapper } from "@hospital/contexts";
import { UserStore } from "@hospital/views/_shared/userprofile/UserStore";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

/**
 * Creates a UserStore with options on whether it should be updated in the UserStore context, and whether it should be recreated when the UserId changes in the route.
 * @param options
 * @returns
 */
export const useCreateUserStore = (configuration: ClientConfigurationModel, options?: { shouldSetContext?: boolean, recreateOnUserIdRoute?: boolean }) => {
    const { userId } = useParams();
    //options object will always be different, so need to store options in state and only update state when the option values change
    const [optionBasedUserId, setOptionBasedUserId] = useState<string | undefined>(undefined);
    const [optionsSetContext, setOptionsSetContext] = useState<boolean>(false);

    useEffect(() => {
        if (options && options.recreateOnUserIdRoute)
            setOptionBasedUserId(userId);
        else
            setOptionBasedUserId(undefined);
        if (options) {
            if (options.recreateOnUserIdRoute)
                setOptionBasedUserId(userId);
            else
                setOptionBasedUserId(undefined);
            if (options.shouldSetContext)
                setOptionsSetContext(true);
            else
                setOptionsSetContext(false);
        }
    }, [options, userId]);

    const [store] = useMemo(() => {
        const store = new UserStore({ configuration, strUserId: optionBasedUserId });
        if (optionsSetContext)
            UserStoreContextWrapper.set(store);
        return [store]
    }, [configuration, optionBasedUserId, optionsSetContext]); //<- if recreateOnUserIdRoute was true, optionBasedUserId will be the current userId from useParams, and it changing will recreate the user store here.
    return store;
}
